module.exports = __webpack_public_path__ + "img/aptamil-1plus-1200g.5c6086ee.png";